import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setLevantamentoDeStatusVacinal(params: Params) {
  const { questions, formMethods } = params

  const { watch } = formMethods

  const tagForQuestion = Object.fromEntries(questions.flatMap((q) => q.tags.map((tag: string) => [tag, q.slug])))

  const vacinaHepatiteB_recebeu = watch(`form_answers.${tagForQuestion['vacinaHepatiteB_recebeu']}`)

  const vacinaDifteriaTetano_recebeu = watch(`form_answers.${tagForQuestion['vacinaDifteriaTetano_recebeu']}`)

  const vacinaFebreAmarela_recebeu = watch(`form_answers.${tagForQuestion['vacinaFebreAmarela_recebeu']}`)

  const vacinaTripliceViral_recebeu = watch(`form_answers.${tagForQuestion['vacinaTripliceViral_recebeu']}`)

  const vacinaPneumococica23Valente_recebeu = watch(
    `form_answers.${tagForQuestion['vacinaPneumococica23Valente_recebeu']}`
  )

  const vacinaVaricela_recebeu = watch(`form_answers.${tagForQuestion['vacinaVaricela_recebeu']}`)

  const vacinaInfluenzaTrivalente_recebeu = watch(`form_answers.${tagForQuestion['vacinaInfluenzaTrivalente_recebeu']}`)

  const vacinaCovid19_recebeu = watch(`form_answers.${tagForQuestion['vacinaCovid19_recebeu']}`)

  const filteredQuestions = questions.filter((question) => {
    //Hepatite B
    if (question.tags.includes('vacinaHepatiteB_doses') || question.tags.includes('vacinaHepatiteB_dataUltimaDose')) {
      if (vacinaHepatiteB_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // Difteria e Tétano
    if (
      question.tags.includes('vacinaDifteriaTetano_doses') ||
      question.tags.includes('vacinaDifteriaTetano_dataUltimaDose')
    ) {
      if (vacinaDifteriaTetano_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // Febre Amarela
    if (question.tags.includes('vacinaFebreAmarela_dataUltimaDose')) {
      if (vacinaFebreAmarela_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // Tríplice Viral
    if (
      question.tags.includes('vacinaTripliceViral_doses') ||
      question.tags.includes('vacinaTripliceViral_dataUltimaDose')
    ) {
      if (vacinaTripliceViral_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // Pneumocócica 23-valente
    if (question.tags.includes('vacinaPneumococica23Valente_doses')) {
      if (vacinaPneumococica23Valente_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // Varicela
    if (question.tags.includes('vacinaVaricela_doses')) {
      if (vacinaVaricela_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // Influenza Trivalente
    if (question.tags.includes('vacinaInfluenzaTrivalente_dataUltimaDose')) {
      if (vacinaInfluenzaTrivalente_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    // COVID 19
    if (question.tags.includes('vacinaCovid19_dataUltimaDose')) {
      if (vacinaCovid19_recebeu === 'Sim') {
        return true
      } else {
        return false
      }
    }

    return true
  })

  return filteredQuestions
}
